import React from "react";
import Phonecall from "../../Images/phoencalimage.png";
import Address from "../../Images/adressimage.png";
import Emailimage from "../../Images/emailimage.png";
import Footer from "./Footer";
import HomeNavbar from "./HomeNavbar";
function Contactus() {
  return (
    <>
      <HomeNavbar />
      <div
        id="contact-us"
        className="bg-white w-full py-12  text-center font-oswald"
      >
        <div className=" flex items-center justify-center">
          <p
            style={{ backgroundColor: "#EFEEFE" }}
            className="  rounded-full py-2 px-6 font-bold text-bgBlue"
          >
            Contact Us
          </p>
        </div>
        <br />
        <h2 className="text-3xl font-bold text-gray-900 mb-2 animate-fade-in">
          Let's Connect <span className="text-purple">Together </span>{" "}
        </h2>
        <p className=" text-sm text-gray-900 mb-4 animate-fade-in lg:w-1/2 lg:m-auto ">
          To increse Knowledge and earn more
        </p>
        <br />

        <div className="flex lg:flex-row gap-2  lg:px-28 flex-col">
          <div class=" flex justify-center itmes-center  lg:w-1/2 w-full m-auto ">
            <div className="flex flex-col justify-center itmes-center  m-auto gap-4 w-96">
              <div
                style={{ backgroundColor: "#F5F5F5" }}
                class="   shadow-[6px_6px_#A695AE]  p-4 rounded-xl h-auto w-full "
              >
                <div className="flex  gap-6 ml-4 items-center">
                  <div className="  flex ">
                    <img src={Address} alt="" className="w-24 h-14" />
                  </div>

                  <div class="flex flex-col gap-4  lg:m-0 text-start  ">
                    <span class=" text-xl font-semibold font-oswald text-black ">
                      Address
                    </span>
                    <span class=" text-sm font-bold text-start ">
                      9,SHANKAR SHREE,COMPLEX ND 3, Burhanpur, East Nimar -
                      450331, Madhya Pradesh
                    </span>
                  </div>
                </div>
              </div>

              <div
                style={{ backgroundColor: "#F5F5F5" }}
                class="   max-w-md shadow-[6px_6px_#A695AE]  p-4 rounded-xl h-28  "
              >
                <div className="flex  gap-6 ml-4 items-center">
                  <div className="  flex    ">
                    <img src={Phonecall} alt="" className="w-12 h-12 " />
                  </div>

                  <div class="flex flex-col gap-4  lg:m-0 text-start  ">
                    <span class=" text-xl font-semibold font-oswald text-black ">
                      Phone
                    </span>
                    <span class=" text-sm font-bold text-start  ">
                      7898079499,7067373846
                    </span>
                  </div>
                </div>
              </div>

              <div
                style={{ backgroundColor: "#F5F5F5" }}
                class="   max-w-md shadow-[6px_6px_#A695AE]  p-4 rounded-xl h-28  "
              >
                <div className="flex w-full  gap-6 ml-4 items-center">
                  <div className="  flex    ">
                    <img src={Emailimage} alt="" className="w-12 h-12 " />
                  </div>

                  <div class="flex flex-col gap-4  lg:m-0 text-start  ">
                    <span class=" text-xl font-semibold font-oswald text-black ">
                      E-mail Address
                    </span>
                    <span class=" text-sm font-bold text-start  ">
                      support@learn2earn24x7.com
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:w-1/2 w-full ">
            <div className=" w-full   p-4">
              <div class="flex  items-center justify-start bg-white ">
                <div
                  style={{ backgroundColor: "#F5F5F5" }}
                  class="w-full  text-black h-96 rounded-xl p-4"
                >
                  <form class="mt-10">
                    <input type="hidden" />
                    <div class="grid gap-6 sm:grid-cols-2 gap-4">
                      <div class="relative z-0 ">
                        <input
                          type="text"
                          name="name"
                          class="peer block w-full appearance-none border-0 border-b border-gray-500 bg-transparent py-2.5 px-0 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0"
                          placeholder=" "
                        />
                        <label class="absolute top-3 left-0 -z-10 origin-[0] -translate-y-6 scale-75 transform text-sm text-text-black duration-300    text-start peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:text-blue-600 peer-focus:dark:text-blue-500">
                          First Name
                        </label>
                      </div>
                      <div class="relative z-0">
                        <input
                          type="text"
                          name="email"
                          class="peer block w-full appearance-none border-0 border-b border-gray-500 bg-transparent py-2.5 px-0 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0"
                          placeholder=" "
                        />
                        <label class="absolute left-0  top-3 -z-10 origin-[0] -translate-y-6 scale-75 transform text-sm text-text-black duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:text-blue-600 peer-focus:dark:text-blue-500">
                          Last Name
                        </label>
                      </div>
                    </div>
                    <br />
                    <div class="relative z-0">
                      <input
                        type="text"
                        name="email"
                        class="peer block w-full appearance-none border-0 border-b border-gray-500 bg-transparent py-2.5 px-0 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0"
                        placeholder=" "
                      />
                      <label class="absolute left-0  top-3 -z-10 origin-[0] -translate-y-6 scale-75 transform text-sm text-text-black duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:text-blue-600 peer-focus:dark:text-blue-500">
                        Your Email
                      </label>
                    </div>
                    <br />
                    <div className="mt-4">
                      <h1 className="text-start mt-2 mb-2">
                        What Topic's are Interested you?
                      </h1>
                      <br />
                      <div className="flex gap-4">
                        <div class="flex items-center">
                          <input
                            id="checked-checkbox"
                            type="checkbox"
                            value=""
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                          <label
                            for="checked-checkbox"
                            class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                          >
                            SSC
                          </label>
                        </div>
                        <div class="flex items-center">
                          <input
                            id="checked-checkbox"
                            type="checkbox"
                            value=""
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                          <label
                            for="checked-checkbox"
                            class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                          >
                            Banking
                          </label>
                        </div>
                        <div class="flex items-center">
                          <input
                            id="checked-checkbox"
                            type="checkbox"
                            value=""
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                          <label
                            for="checked-checkbox"
                            class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                          >
                            Railways
                          </label>
                        </div>
                        <div class="flex items-center">
                          <input
                            id="checked-checkbox"
                            type="checkbox"
                            value=""
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                          />
                          <label
                            for="checked-checkbox"
                            class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                          >
                            PSC
                          </label>
                        </div>
                      </div>
                    </div>

                    <button
                      type="submit"
                      class="mt-5 rounded-md bg-bgBlue w-full px-4 py-2 text-white"
                    >
                      Send Message
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ width: "100%", height: "400px" }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4046.621197932841!2d76.22066327694696!3d21.302954357070007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd831e3fed42e91%3A0xf61cb28c73e530a0!2sAkrypt%20Technologies!5e0!3m2!1sen!2sin!4v1761903150425!5m2!1sen!2sin"
          width="100%"
          height="450"
          // style="border:0;"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
          marginBottom={10}
        ></iframe>
      </div>
      <br></br>
      <br></br>
      <Footer />
    </>
  );
}

export default Contactus;
